import { render } from "./Contact.vue?vue&type=template&id=3f05af26"
const script = {}
script.render = render

export default script